import { render, staticRenderFns } from "./cigarette.vue?vue&type=template&id=13a35d94&scoped=true"
import script from "./cigarette.vue?vue&type=script&lang=js"
export * from "./cigarette.vue?vue&type=script&lang=js"
import style0 from "./cigarette.vue?vue&type=style&index=0&id=13a35d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a35d94",
  null
  
)

export default component.exports